import type { ReactNode } from 'react';

export type FormatName = 'Bold' | 'Italic' | 'Underline' | 'Strikethrough' | 'Bulleted list' | 'Numbered list' | 'Insert link';
const paths: Record<FormatName | 'Format' | 'Emoji' | 'Attach file', ReactNode> = {
  Format: <><path d="m3 17 5-13 5 13M5 12h6M14 20l6-6 2 2-6 6h-2z" /></>,
  Emoji: <><circle cx="12" cy="12" r="9" /><path d="M8 9h.01M16 9h.01M7.5 14a5 5 0 0 0 9 0" /></>,
  'Attach file': <path d="m8 12 7-7a4 4 0 0 1 6 6L10 22a6 6 0 0 1-8-8L13 3m-8 14 11-11a1.5 1.5 0 0 1 2 2L8 18a2 2 0 0 1-3-1" />,
  Bold: <path d="M6 4h7a4 4 0 0 1 0 8H6V4Zm0 8h8a4 4 0 0 1 0 8H6v-8Z" />,
  Italic: <path d="M10 4h9M5 20h9M15 4 9 20" />,
  Underline: <path d="M6 4v8a6 6 0 0 0 12 0V4M4 21h16" />,
  Strikethrough: <path d="M18 6c-3-4-13-3-12 2 .4 2 3 3 6 4m6 3c2 6-10 7-13 3M3 12h18" />,
  'Bulleted list': <><path d="M9 5h12M9 12h12M9 19h12" /><circle cx="3" cy="5" r="1" /><circle cx="3" cy="12" r="1" /><circle cx="3" cy="19" r="1" /></>,
  'Numbered list': <path d="M10 5h11M10 12h11M10 19h11M2 3h2v5M2 8h4M2 12c0-3 5-3 4 0l-4 5h4M2 20h4" />,
  'Insert link': <path d="m10 14 4-4M8 16l-2 2a4 4 0 0 1-6-6l5-5a4 4 0 0 1 6 0m2 1 2-2a4 4 0 0 1 6 6l-5 5a4 4 0 0 1-6 0" />,
};
export function ComposerIcon({ name }: { name: keyof typeof paths }) {
  return <svg viewBox="0 0 24 24" aria-hidden="true">{paths[name]}</svg>;
}
